module.exports = __webpack_public_path__ + "static/cover-9023f44c1ffb2830375559819a1ab1e6.png";